import { createAction } from '@reduxjs/toolkit';

import { GlobalActionTypes } from '@/types';

const logout = createAction(GlobalActionTypes.ClearStore);

export default {
  logout,
};
